import Cookies from 'js-cookie';
// import { encode } from "universal-base64";
import APIS from '@/util/apis';
import {GetQueryString, stringToObj, objToUrlParams, dateFormater} from '@/lib/util';
import payUnit from '@/lib/payUnit';
//import payUnit from '@/frontend-lib/lib/payUnit'
import base64 from '@/lib/base64'
import Base64 from '@public/lib/base64';
import {Stream} from 'xstream';
import '@/lib/dialog';

import toast from '@/lib/toast';
import pageJumperMixin from '@/mixins/pageJumper-mixin';
import loading from '@/lib/loading';
import {getPlatform} from '@/util/tool';
import {isMeiTuanMp} from "../entry/templateCommon";
// import vconsole from 'vconsole';
// new vconsole()
const platform = getPlatform();
const isAPP = platform.isYixinliApp;

// 购买的请求
function buyRequest(params,userKey) {
  window.monitor.stat({
    logType: 'pay',
    message: JSON.stringify(Object.assign(params, {href: location.href})),
    title: '测评-支付日志',
    url: '/api/buyScale',
    userKey: userKey
  })
  console.log('--- buyRequest --- params', params)
  return Stream.ajax('/api/buyScale', params, 0)
}


// 购买的请求
function buyVipRequest(params,userKey) {
  window.monitor.stat({
    logType: 'pay',
    message: JSON.stringify(Object.assign(params, {href: location.href})),
    title: '测评-支付日志',
    url: '/lx/vip/buy',
    userKey: userKey
  })
  return Stream.ajax('/lx/vip/buy', params, 0)
}

// 20201111 购买的请求
function buyDoubleElevenRequest(params,userKey) {
    window.monitor.stat({
        logType: 'pay',
        message: JSON.stringify(Object.assign({}, params, {href: location.href})),
        title: '测评-支付日志',
        url: '/lx/doubleEleven/buyDoubleElevenScales',
        userKey: userKey
    })
    return Stream.ajax('/lx/doubleEleven/buyDoubleElevenScales', params, 0)
}

function buyPackQingSu(params,userKey) {
  window.monitor.stat({
    logType: 'pay',
    message: JSON.stringify(Object.assign({}, params, {href: location.href})),
    title: '测评-支付日志',
    url: 'doFirstAfterBuy/createOrder',
    userKey: userKey
  })
  return Stream.ajax(`${APIS.cpapiHost}doFirstAfterBuy/createOrder`, params, 0)
}

function buyDepression(params,userKey) {
    window.monitor.stat({
        logType: 'pay',
        message: JSON.stringify(Object.assign({}, params, {href: location.href})),
        title: '测评-支付日志',
        url: 'depressed/buyDepressedPackage',
        userKey: userKey
    })
    return Stream.ajax(`${APIS.lingxiHost}depressed/buyDepressedPackage`, params, 0)
}

function buyCpVip(params,userKey) {
  window.monitor.stat({
    logType: 'pay',
    message: JSON.stringify(Object.assign({}, params, {href: location.href})),
    title: '测评-支付日志',
    url: 'api/buyCpVip',
    userKey: userKey
  })
  return Stream.ajax(`${APIS.LXKC}api/buyCpVip`, params, 0)
}

let orderDataOperate = {
    set(name, data) {
        localStorage.removeItem(name);
        localStorage.setItem(name, JSON.stringify(data));
        // storgeData写多一次在cookie做保险，设置时间是三分钟后过期
        let nowDate = new Date();
        nowDate.setMinutes(nowDate.getMinutes() + 3)
        Cookies.remove(name);
        Cookies.set(name, data, {expires: nowDate});
    },
    get(name) {
        if (localStorage.getItem(name)) {
            console.log('localStorageData', JSON.parse(localStorage.getItem(name)));
            return JSON.parse(localStorage.getItem(name));
        } else if (Cookies.get(name)) {
            console.log('CookieData', JSON.parse(Cookies.get(name)));
            return JSON.parse(Cookies.get(name));
        } else {
            return null;
        }
    },
    remove(name) {
        Cookies.remove(name);
        localStorage.removeItem(name);
    }
}

// 购买后的逻辑判断
function afterBuy(res, buyParams, userKey, payType) {
    const isDepression = +buyParams.scalePoolId === 696
    return new Promise((resolve, reject) => {
        const {code, data} = res;
        if (+code === 2001) {
            if (payType == 'MEMBER') {
                return
            }
            // 抑郁单品直接跳转到答题页
            if (isDepression) {
                location.href = data.url
                return
            }
            console.log('---此处应有弹窗询问是否继续购买---')
            const boughtDay = new Date(data.buyTime);
            let dialogContent = '';
            let cancelText = '';
            if (data.finished) {
                dialogContent = `亲，该测评您于${boughtDay.getFullYear()}年${boughtDay.getMonth() + 1}月${boughtDay.getDate()}日${boughtDay.getHours()}:${boughtDay.getMinutes()}:${boughtDay.getSeconds()}买过，是否确定再次购买？（重复支付不予退款）`;
                cancelText = '查看报告';
            } else {
                dialogContent = `亲，该测评您有未完成记录，是否继续答题？`;
                cancelText = '去做题';
            }
            Stream.dialog(`${dialogContent}`, '去支付', cancelText, {
                cancelValue: 'report',
                onClose: () => {
                }
            })
                .take(1)
                .addListener({
                    next(res) {
                        console.log(`购买弹窗结果是`, res);
                        if (res.value === 'report') {
                            location.href = data.url;
                        } else {
                            buyParams.goonBuy = 1;
                            buyRequest(buyParams,userKey).toPromise().then(res => {
                                afterBuy(res, buyParams, userKey, payType);
                            });
                        }
                    }
                });
        } else if (+code === 1) {
            console.log('返回的状态是1 购买类型', buyParams)
            let isApp = platform.isYixinliApp || platform.isCeShiApp
            if (buyParams.tradeType.indexOf('WX_H5_PAY') !== -1) {
                // payUnit.wxJsPay()
                // console.log('app 原生 ping++ 支付的数据', result)
                if (data.mweb_url) {
                    let payIframe;
                        // 设置localStorage去被查询
                        let storgeData = {
                            orderId: data.orderId,
                            channelId: buyParams.channelId,
                            scalePoolId: buyParams.scalePoolId,
                            pageScaleId: buyParams.pagescaleId,
                            userKey: userKey,
                            date: new Date()
                        };

                        orderDataOperate.set('yxl_cp_buyData', storgeData);
                        let orderDataPromise = new Promise((resolve, rejsct) => {
                            let counter = 0;
                            let intervalId = setInterval(() => {
                                console.log('轮询yxl_cp_buyData写入情况')
                                counter++;
                                if (orderDataOperate.get('yxl_cp_buyData')) {
                                    console.log('yxl_cp_buyData写入成功', orderDataOperate.get('yxl_cp_buyData'));
                                    clearInterval(intervalId);
                                    resolve({});
                                } else if (counter === 5){
                                    console.log('yxl_cp_buyData写入失败', orderDataOperate.get('yxl_cp_buyData'));
                                    resolve({useUrlOrderId: 1});
                                }
                            }, 250);
                        });

                    if (document.getElementById('payIframe')) {
                        payIframe = document.getElementById('payIframe');
                    } else {
                        payIframe = document.createElement('iframe');
                        payIframe.setAttribute('id', 'payIframe')
                    }
                    document.body.appendChild(payIframe);
                    // payIframe.src = location.href;

                    // 弹窗询问支付状态
                    setTimeout(() => {
                        loading('正在创建订单...');
                    }, 500)

                    orderDataPromise.then((useUrlOrderId) => {
                        if (isAPP) {
                            let urlSearchObj = stringToObj(location.search.replace('?', ''));
                            let mySearchObj = {};
                            mySearchObj.payDone = 1; // payDone 用作IOS调起Safari的标记，安卓不用
                            mySearchObj.random = Math.random(); // 加random去缓存，安卓不用
                            mySearchObj.userId = urlSearchObj.userId; // 只有userId和userKey有用，其他那些个什么ID就不带了
                            mySearchObj.userKey = userKey;
                            mySearchObj.channelId = buyParams.channelId;
                            mySearchObj.orderId = data.orderId;
                            mySearchObj.isCp = 1;
                            let redirectUrl = `${location.origin}${location.pathname}?${objToUrlParams(mySearchObj)}${location.hash}`;
                            console.log(`重定向URL：${redirectUrl}`);
                            if (platform.isiPhone) {
                                let finalUrl = `${data.mweb_url}&redirect_url=${encodeURIComponent(redirectUrl)}`;
                                window.monitor.stat({
                                  logType:'pay',
                                  message:`测评app - 微信H5支付${finalUrl}`,
                                  title:'测评-支付日志',
                                  payParameters: finalUrl,
                                  userKey:userKey,
                                })
                                location.href = finalUrl;
                                // payIframe.src = finalUrl;
                            } else {
                                // payIframe.src = `${data.mweb_url}`; // 这个URL在安卓不生效了，cnm
                                // 客户端使用iframe调起，安卓不用重定向地址，避免还没给完钱就跳回APP

                                let finalUrl = `${data.mweb_url}`;
                                if (payType == 'MEMBER') {
                                    finalUrl = `${data.mweb_url}&redirect_url=${encodeURIComponent(redirectUrl)}`;
                                }
                                console.log(finalUrl)
                                window.monitor.stat({
                                  logType:'pay',
                                  message:`测评app - 微信H5支付${finalUrl}`,
                                  title:'测评-支付日志',
                                  payParameters: finalUrl,
                                  userKey:userKey,
                                  payType: payType
                                })
                                if (payType == 'MEMBER') {
                                    location.href = finalUrl;
                                }else{
                                    payIframe.src = finalUrl;
                                }

                            }
                            // 定时弹出支付成功的询问弹窗，避免页面没刷新而用户回来困惑的场景
                            setTimeout(() => {
                                payDoneComfirm({
                                    orderId: data.orderId,
                                    channelId: buyParams.channelId,
                                    userKey: userKey,
                                    payType: payType
                                });
                            }, 5000);
                        } else {
                            // payIframe.src = data.mweb_url;
                            let urlSearchObj = stringToObj(location.search.replace('?', ''));
                            let mySearchObj = {};
                            mySearchObj.random = Math.random(); // 加random去缓存，安卓不用
                            mySearchObj.userId = urlSearchObj.userId; // 只有userId和userKey有用，其他那些个什么ID就不带了
                            mySearchObj.userKey = userKey;
                            mySearchObj.channelId = buyParams.channelId;
                            if (useUrlOrderId) {
                                mySearchObj.orderId = buyParams.orderId;
                            }
                            let redirectUrl = `${location.origin}${location.pathname}?${objToUrlParams(mySearchObj)}${location.hash}`;
                            console.log(`重定向URL：${redirectUrl}`);
                            let finalUrl = `${data.mweb_url}&redirect_url=${encodeURIComponent(redirectUrl)}`;

                            // 以防微信没有自动调回回调地址，自动重定向一次，微信的时间是5s;
                            setTimeout(() => {
                                payDoneComfirm({
                                    orderId: data.orderId,
                                    channelId: buyParams.channelId,
                                    userKey: userKey,
                                    payType: payType
                                });
                                location.href = redirectUrl;
                            }, 1000);
                            window.monitor.stat({
                              logType:'pay',
                              message:`测评m站 - 微信H5支付${finalUrl}`,
                              payParameters: finalUrl,
                              title:'测评-支付日志',
                              userKey:userKey,
                            })
                            // M站直接跳转
                            location.href = finalUrl;
                        }
                    })

                }
            } else if (['ALI_PAY_APP', 'WX_PAY_APP'].includes(buyParams.tradeType)) {
              console.log('app 原生 ping++ 微信支付的body', data)
              yxlAppPayCeshi({
                  payDaya: payType == 'cpVip' ? data.data : data.body,
                  orderId: payType == 'cpVip' ? data.cpOrderId : data.orderId,
                  channelId: buyParams.channelId,
                  userKey: buyParams.userKey,
                  tradeType: buyParams.tradeType,
                  payType: payType,
              })
              // payUnit.pingppPay(data)
            } else if (buyParams.tradeType.indexOf('ALI_PAY_WAP') !== -1) {
                //修改成直连支付
                payUnit.directAliPay(data).then(() => {
                   if (window.myTracker && window.scaleName) {
                        // window.myTracker.detailPaySuccess(window.scaleName);
                        window.myTracker.send({
                            name: `v5100_测评_支付成功`,
                            properties: {
                                '测评名称': window.scaleName
                            }
                        });
                    }
                    resolve(data);
                })
            } else if (buyParams.tradeType.indexOf('ALI_PAY_MINIAPP') !== -1) {
                my.tradePay({
                    // 支付宝小程序支付专用 alipayTradeNo
                    tradeNO: data.alipayTradeNo,
                    success: (res) => {
                        console.log('=== my.tradePay === success:', res)
                        console.log('=== my.tradePay === success orderId', data.orderId)
                        if (res.resultCode == 9000) {
                            // 支付成功，文档提示这个 code 不一定准
                            // 后端 payDone 接口还会去查一遍是否支付成功
                            aliMpPayCeshi({
                                orderId: data.orderId,
                                channelId: buyParams.channelId,
                                userKey: buyParams.userKey,
                                tradeType: buyParams.tradeType,
                                payType: payType,
                            })
                        } else {
                          toast('支付异常')
                          window.monitor.stat({
                            logType: 'pay',
                            message: JSON.stringify(Object.assign({}, buyParams, {
                              orderId: data.orderId,
                              payType: payType,
                              successRes: res,
                            })),
                            title: '测评-支付日志',
                            url: `my.tradePay success.resultCode != 9000`,
                            userKey: userKey
                          })
                        }
                    },
                    fail: (res) => {
                      window.monitor.stat({
                        logType: 'pay',
                        message: JSON.stringify(Object.assign({}, buyParams, {
                          orderId: data.orderId,
                          payType: payType,
                          failRes: res,
                        })),
                        title: '测评-支付日志',
                        url: `my.tradePay fail`,
                        userKey: userKey
                      })
                        my.alert({
                            content: JSON.stringify(res),
                        });
                    }
                  });
            } else if (buyParams.tradeType.indexOf('MEITUAN_MINI_APP') !== -1) {
                let payData = JSON.stringify({
                    // {\"code\":0,\"msg\":\"一切正常\",\"data\":{\"uni_order_id\":\"4944974465670249024\",\"pay_params\":{\"uni_order_id\":\"4944974465670249024\",\"degrade_status\":false,\"pay_token\":\"14a3a579221ee9f8f39f9f040dce9276\",\"trade_no\":\"24031810100001670004417575589023\",\"need_redirect\":true}}}
                    body: {
                      // tradeno: "24031810100001670004417578605023",
                      // payToken: "fb1b9b20c7d064dfe8af1f4ca0fd3b32",
                      tradeno: data.tradeno,
                      payToken: data.payToken,
                      orderNo: data.orderNo
                    },
                    back_url: window.location.href,
                    // success_url: "https://www.baidu.com",
                    success_url: meituanMpPayCeshi({
                      orderId: data.orderId,
                      channelId: buyParams.channelId,
                      userKey: buyParams.userKey,
                      tradeType: buyParams.tradeType,
                      payType: payType,
                    })
                })

                window.$uniAppNavto.redirect({
                    path: "/pages/pay/pay?data=" + encodeURIComponent(payData)
                })
            }
        } else if (+code === 302) {
            // 标记是从详情页进入下个页面
            location.href = data;
        } else if (+code === 2003) {
            if (isDepression) {
                const boughtDay = new Date(data.buyTime);
                let dialogContent = '';
                let cancelText = '';
                if (!data.remainStatus) {
                    dialogContent = `亲，该测评您于${boughtDay.getFullYear()}年${boughtDay.getMonth() + 1}月${boughtDay.getDate()}日${boughtDay.getHours()}:${boughtDay.getMinutes()}:${boughtDay.getSeconds()}买过，是否确定再次购买？（重复支付不予退款）`;
                    cancelText = '查看报告';
                } else {
                    dialogContent = `亲，该测评您有未完成记录，是否继续答题？`;
                    cancelText = '继续答题';
                }
                Stream.dialog(`${dialogContent}`, '去支付', cancelText, {
                    cancelValue: 'report',
                    onClose: () => {}
                })
                    .take(1)
                    .addListener({
                        next(res) {
                            if (res.value === 'report') {
                                location.href = data.url;
                            } else {
                                buyParams.goonBuy = 1;
                                buyDepression(buyParams,userKey).toPromise().then(res => {
                                    afterBuy(res, buyParams, userKey, payType);
                                });
                            }
                        }
                    });
            }
        } else if (+code === 2004) {
            // 抑郁单品
            if (isDepression) {
                let tips = ''
                if (data && data.repeTestIntevalDays && data.nextTestTime) {
                    tips = `该测评连续测试的最佳间隔时长是${
                        data.repeTestIntevalDays
                    }天，下次测试时间在${
                        dateFormater(new Date(data.nextTestTime), 'YYYY年MM月DD号 hh:mm:ss')
                    }或更后。`
                } else {
                    tips = data.msg
                }
                Stream.dialog(tips, '关闭', '取消', {
                    cancelValue: 'false',
                }).take(1).addListener({
                    next() {}
                });
                setTimeout(() => {
                    document.querySelectorAll('.cp-dialog__footer a')[1].style.display = 'none'
                })
                return
            }
        } else if (+code === 2005) {
            if (isDepression) {
                buyParams.repeatTestBuy = 1
                buyDepression(buyParams, userKey).toPromise().then(res => {
                    afterBuy(res, buyParams, userKey, payType)
                })
            }
        } else if (+code === 2030) {
          // doFirstAfterBuy/createOrder 目前处理这个接口的返回
          if (isMeiTuanMp) {
            // 未完成
            let dialogContent = '你有该测评的未完成记录，可继续答题';
            let cancelText = '继续答题';
            Stream.dialog(`${dialogContent}`, '取消', cancelText, {
              cancelValue: 'answerList',
              onClose: () => {}
            })
              .take(1)
              .addListener({
                next(res) {
                  if (res.value === 'answerList') {
                    location.href = data;
                  }
                }
              });
          }
        } else if (+code === 2031) {
          // doFirstAfterBuy/createOrder 目前处理这个接口的返回
          if (isMeiTuanMp) {
            // 已完成
            let dialogContent = '您已完成答题，提交报告成功';
            let cancelText = '去支付';
            Stream.dialog(`${dialogContent}`, '知道了', cancelText, {
              cancelValue: 'report',
              onClose: () => {}
            })
              .take(1)
              .addListener({
                next(res) {
                  if (res.value === 'report') {
                    location.href = data;
                  }
                }
              });
          }
        }
    });
}

// 发起支付后的询问和JS的处理
function payDoneComfirm({orderId, channelId, userKey, payType}) {
    let getUserKey = userKey || this.$route.query.userKey || GetQueryString('userKey')
    Stream.dialog(`是否已支付成功？`, '支付成功', '取消', {cancelValue: false})
        .take(1)
        .filter(res => {
            if (res.value === false) {
                console.log('点击取消，删掉本地存储的订单数据，避免老是询问');
                // localStorage.removeItem(`yxl_cp_buyData`);
                orderDataOperate.remove('yxl_cp_buyData');
            }
            // 不等于false才走下一步
            return res.value !== false
        })
        .addListener({
            next(res) {
                console.log('---回调支付状态---')
                // 成功跳转前，把之前保存的本地存储去掉
                // localStorage.removeItem(`yxl_cp_buyData`);
                orderDataOperate.remove('yxl_cp_buyData');
                if (payType != 'MEMBER') {
                   toast('正在前往答题');
                }

                // 微信H5跳转之前记录购买成功埋点
                if (window.myTracker && window.scaleName) {
                    // window.myTracker.detailPaySuccess(window.scaleName);
                    window.myTracker.send({
                        name: `v5100_测评_支付成功`,
                        properties: {
                            '测评名称': window.scaleName
                        }
                    });
                }
                if (payType == 'MEMBER') {
                    console.log('跳转 -- vipPayDone')
                    pageJumperMixin.methods.openUrl(`${location.protocol}${APIS.lingxiHost}vipPayDone/${getUserKey}/${orderId}`);
                } else {
                    console.log('跳转 -- platformDone')
                    if (payType === 'depression') {
                        location.href = `${location.protocol}${APIS.lingxiHost}depressed/pay/done/${orderId}?userKey=${userKey}&channelId=${channelId}`
                    } else {
                        pageJumperMixin.methods.openUrl(`${location.protocol}${APIS.cpapiHost}pay/platformDone/${orderId}/${channelId}/${getUserKey}`);
                    }
                }
                // 这接口使用直接跳转而不是异步请求

            }
        });
}

function pageLoadCheckWxH5Order({channelId, userInfo, scalePoolId, pageScaleId, urlOrderId, payType}) {
    // strogeData 由orerId 和渠道id拼接而成
    let strogeData = orderDataOperate.get('yxl_cp_buyData');
    let strogeDataPromise = new Promise((resolve, reject) => {
        let counter = 0;
        let intervelId;
        if (strogeData || urlOrderId) {
            resolve();
            return ;
        } else if (!strogeData && !urlOrderId) {
            intervelId = setInterval(() => {
                console.log('没有urlOrderId，轮询查找本地存储订单数据');
                counter++;
                if (orderDataOperate.get('yxl_cp_buyData')) {
                    strogeData = orderDataOperate.get('yxl_cp_buyData');
                    console.log(`查了${counter}次`, strogeData);
                    clearInterval(intervelId);
                    resolve();
                } else if (counter === 5) {
                    console.log('查了5次都没数据，走人');
                    clearInterval(intervelId);
                    reject('No data');
                }
            }, 200);
        }
    })

    console.log('拿到的本地订单数据', strogeData)

    strogeDataPromise.then(() => {
        let orderId, storageChannelId, strogeScalePoolId, strogePageScaleId, strogeUserKey, orderIdTime;
        if (strogeData) {
            orderId = strogeData.orderId;
            storageChannelId = strogeData.channelId;
            strogeScalePoolId = strogeData.scalePoolId;
            strogePageScaleId = strogeData.pageScaleId;
            strogeUserKey = strogeData.userKey;

            orderIdTime = strogeData.date;

            if ((orderId !== undefined) && (orderIdTime !== undefined)) {
                if (pageScaleId && (strogePageScaleId !== pageScaleId)) {
                    // 避免所有测评详情页都提示，只在相同测评的详情页提示
                    console.log(`---传入测评页面ID并且存储的测评页面ID不一致，停止继续：${strogeScalePoolId} !== ${scalePoolId}---`);
                    return;
                }
                //  & storageChannelId == channelId 原本有判断渠道
                // console.log(`---渠道一致:${storageChannelId}---`);
                let timeDistance = (new Date(orderIdTime) - new Date()) / 1000;
                console.log(`---检测到H5订单号:${orderId}---`);
                if (timeDistance < 180) {
                    // 订单时间小于三分钟，开始轮询
                    console.log('---三分钟内有此渠道此测评的WX-H5，订单提示用户---');
                    payDoneComfirm({
                        orderId,
                        buyParams: {
                            scalePoolId: strogeScalePoolId,
                            tradeType: 'WX_H5_PAY'
                        },
                        userKey: strogeUserKey,
                        channelId: storageChannelId,
                        payType: payType
                    });

                } else {
                    // 时间大于三分钟，把localStorge清除
                    console.log('---H5订单号已过期，正在清除---');
                    setTimeout(() => {
                        // localStorage.removeItem(`yxl_cp_buyData`);
                        orderDataOperate.remove('yxl_cp_buyData');

                    }, 5000);
                }
            }
        } else if (urlOrderId) {
            console.log(`---传入urlOrderId, ${urlOrderId}---`);
            payDoneComfirm({
                orderId: urlOrderId,
                channelId: channelId,
                userKey: userInfo.userKey,
                payType:payType
            });
            return;
        }
    }).catch(() => {
        console.log(`没有测评H5订单`);
        setTimeout(() => {
            // localStorage.removeItem(`yxl_cp_buyData`);
            orderDataOperate.remove('yxl_cp_buyData');
        }, 5000);
    });
}

function aliMpPayCeshi({orderId, channelId, userKey, tradeType, payType}) {
    let successUrl = `${location.protocol}${APIS.cpapiHost}pay/platformDone/${orderId}/${channelId}/${userKey}`

    if (payType === 'depression') {
      successUrl = `${location.protocol}${APIS.lingxiHost}depressed/pay/done/${orderId}?userKey=${userKey}&channelId=${channelId}`
    }

    location.href = successUrl
}

function meituanMpPayCeshi({orderId, channelId, userKey, tradeType, payType}) {
  let successUrl = `${location.protocol}${APIS.cpapiHost}pay/platformDone/${orderId}/${channelId}/${userKey}`
  if (payType === 'depression') {
    successUrl = `${location.protocol}${APIS.lingxiHost}depressed/pay/done/${orderId}?userKey=${userKey}&channelId=${channelId}`
  }
  return successUrl
}


function yxlAppPayCeshi({payDaya, orderId, channelId, userKey, tradeType, payType}) {
  let payway = tradeType === 'WX_PAY_APP' ? 'weixin' : 'alipay'

  let successUrl = `${location.protocol}${APIS.cpapiHost}pay/platformDone/${orderId}/${channelId}/${userKey}`
  if (payType == 'doubleEleven2020') {
    successUrl += '?sourceName=doubleEleven'
  }

  if (payType === 'depression') {
    successUrl = `${location.protocol}${APIS.lingxiHost}depressed/pay/done/${orderId}?userKey=${userKey}&channelId=${channelId}`
  }

  let appResult = {
    payway,
    data: payDaya,
    type: 'test',
    success_url: successUrl,
  }
  if (payType == 'cpVip') {
    // 测评会员接口返回的数据格式为 base64 和其他接口不同， 替换 base64 的成功回调
    let body = Base64.decode(payDaya)
    let cpResult = JSON.parse(body)
    if (payway == 'weixin') {
      cpResult['data'] = cpResult.data ? JSON.parse(cpResult.data) : {}
    }
    cpResult['success_url'] = successUrl
    appResult = cpResult
  }

  let appResultStr = JSON.stringify(appResult)
  let transtedStr = ''
  let encodedStr = ''
  for(var i = 0; i < appResultStr.length; i++) {
    transtedStr = transtedStr + base64.chineseWordToUnicode(appResultStr.charAt(i))
  }
  encodedStr = base64.encode(transtedStr)

  console.log('appResult', appResult)
  console.log('transtedStr', transtedStr)
  console.log('encodedStr', encodedStr)
  const paySuccessStat = {
    name: '支付-交互行为',
    properties: {
      '行为': '完成支付',
      '支付结果': '成功',
      '支付方式': payway,
      '对象': '测试'
    }
  }
  console.log(`yixinli://process_payment?data=${encodedStr}&successStat=${encodeURIComponent(JSON.stringify(paySuccessStat))}`)
  location.href = `yixinli://process_payment?data=${encodedStr}&successStat=${encodeURIComponent(JSON.stringify(paySuccessStat))}`
}




export default {
    buyRequest,
    afterBuy,
    payDoneComfirm,
    pageLoadCheckWxH5Order,
    buyVipRequest,
    buyDoubleElevenRequest,
    buyPackQingSu,
    buyDepression,
    buyCpVip,
}
export {
    buyRequest,
    afterBuy,
    payDoneComfirm,
    pageLoadCheckWxH5Order,
    buyVipRequest,
    buyDoubleElevenRequest,
    buyPackQingSu,
    buyDepression,
    buyCpVip,
}



// WEBPACK FOOTER //
// ./src/util/buyScaleFun.js